import { Component, OnInit } from '@angular/core';
// import { UserService } from '../../../core/user/user.service';
import { Observable } from 'rxjs';
// import { User } from '../../../core/user/user';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    // user$: Observable<User>;
    // constructor(private userService: UserService) { }

    ngOnInit(): void {
        // this.user$ = this.userService.getUser();
    }

    /**
     * Método responsável por definir a visibilidade do component
     * @returns flag indicando a visibilidade
     */
    isComponentVisible(): boolean {
        // return this.userService.isLogged();
        return true;
    }
}
